export default __webpack_public_path__ + "static/media/paris-cdg.8bdbf14a.webp";